const fieldValidation = {
  required: '{{fieldName}} is required',
  pattern: '{{fieldName}} is invalid',
};

export default fieldValidation;
